import { render, staticRenderFns } from "./TransportationSegment.vue?vue&type=template&id=51a9fbee&scoped=true"
import script from "./TransportationSegment.vue?vue&type=script&lang=js"
export * from "./TransportationSegment.vue?vue&type=script&lang=js"
import style0 from "./TransportationSegment.vue?vue&type=style&index=0&id=51a9fbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a9fbee",
  null
  
)

export default component.exports